import type {
  InstanceScopedEntityType,
  InstanceScopedNamespacePath,
} from "building-types/components/instanceScopedNamespacePathTypes";

/**
 * Filters paths to only those without componentInstanceChain (doc-native entities).
 * These are entities that exist directly in the document, not as part of component instances.
 */
export function filterDocNativePaths<T extends InstanceScopedEntityType>(
  paths: readonly InstanceScopedNamespacePath<T>[],
): InstanceScopedNamespacePath<T>[] {
  return paths.filter((path) => !path.componentInstanceChain);
}

/**
 * Filters paths to only those with componentInstanceChain (ephemeral/component-instance entities).
 * These are entities that exist within component instances and are not directly in the document.
 */
export function filterEphemeralPaths<T extends InstanceScopedEntityType>(
  paths: readonly InstanceScopedNamespacePath<T>[],
): InstanceScopedNamespacePath<T>[] {
  return paths.filter((path) => path.componentInstanceChain);
}
